import React from "react";
import { cn } from "../../../utils/tw";

export interface Option {
  value: string;
  label: string;
}

interface StyledSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: Option[];
  error?: string;
}

const StyledSelect = React.forwardRef<HTMLSelectElement, StyledSelectProps>(
  ({ label, options, error, className, id, required, ...props }, ref) => {
    const selectId = id || props.name || label.toLowerCase().replace(/\s+/g, "-");
    return (
      <div className="space-y-1">
        <label htmlFor={selectId} className="text-xs text-text-muted">
          {label} {required && "*"}
        </label>
        <select
          ref={ref}
          id={selectId}
          className={cn(
            'w-full border border-border-default bg-bg-surface px-3 py-2 rounded-lg outline-none focus:border-ds-primary-500 focus:ring-1 focus:ring-ds-primary-500/30 min-h-[48px] text-text-primary',
            error && 'border-border-error focus:border-border-error focus:ring-ds-status-error-main/30',
            className
          )}
          required={required}
          {...props}
        >
          <option value="">Select</option>
          {options.map(o => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        {error && <p className="text-ds-status-error-main text-xs">{error}</p>}
      </div>
    );
  }
);
StyledSelect.displayName = "StyledSelect";

export default StyledSelect;
